import * as React from 'react';
import {AppRouting} from '../../AppConstants';
import { NavLink } from 'react-router-dom';
import styles from './Sidebar.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faArrowLeft,
    faArrowRightFromBracket, faCircleInfo,
} from '@fortawesome/free-solid-svg-icons';
import { LocalStorageGet, LocalStorageSet } from '../../Services/Helpers';
import globalIcon from '../Icons/buss_icon_global_rgb.svg';
import effectivenessIcon from '../Icons/buss_icon_effectiveness_rgb.svg';
import conditionIcon from '../Icons/buss_icon_condition_rgb.svg';
import serviceIcon from '../Icons/buss_icon_support_rgb.svg';
import administrationIcon from '../Icons/buss_icon_administration_rgb.svg';
import { authService } from '../../index';
import { ReactSVG } from 'react-svg';
import {popoverDialogStore} from "../PopoverDialog/PopoverDialog";
import {TermsAndConditionsContent} from "./Components/TermsAndConditionsContent";
import {useContext} from "react";
import {AppStoreContext} from "../../Stores/AppStore";
import {observer} from "mobx-react";

type Routes = {
    url: string,
    icon?: string,
    label: string,
    hidden?: boolean
}
const LS_NAME = 'sidebarCollapsed';
export const Sidebar = observer(() => {
    const { filtersStore } = useContext(AppStoreContext);

    const { isAdmin } = authService;
    const [collapsed, setCollapsed] = React.useState<boolean>(LocalStorageGet<boolean>(LS_NAME) || false);
    const routes: Routes[] = React.useMemo(() => {
        let defaultRoutes = [
            {
                url: AppRouting.Global,
                label: 'Global',
                icon: globalIcon
            }
        ];
        let serviceAdministrationRoutes = [
            {
                url: AppRouting.Service,
                label: 'Service',
                icon: serviceIcon
            },
            {
                url: AppRouting.Administration,
                label: 'Administration',
                icon: administrationIcon,
                hidden: !isAdmin
            }
        ];
        if(filtersStore.isIoTSubscription){
            return (
                [
                    ...defaultRoutes,
                    ...[
                        {
                            url: AppRouting.Condition,
                            label: 'Condition',
                            icon: conditionIcon
                        },
                        {
                            url: AppRouting.Effectiveness,
                            label: 'Effectiveness',
                            icon: effectivenessIcon
                        },

                    ],
                    ...serviceAdministrationRoutes
                ]
            )
        }
        return [
            ...defaultRoutes,
            ...serviceAdministrationRoutes
        ]
    }, [filtersStore.isIoTSubscription, isAdmin]);

    const _toggle = (event: React.MouseEvent<HTMLDivElement>) => {
        event.stopPropagation();
        LocalStorageSet<boolean>(LS_NAME, !collapsed);
        setCollapsed(!collapsed);
    };
    const _signOut = () => {
        void authService.signOut();
    };

    const renderTermsAndConditionsContent = () => {
        return (<TermsAndConditionsContent />);
    }

    return (
        <div className={`${styles.sidebar} ${collapsed ? styles.collapsed : ''}`}>
            <div className={styles.body}>
                <div className={styles.logo}>
                    <span
                        className={styles.img}/>
                </div>
                <div className={styles.menu}>
                    {routes.map(route => {
                        const { icon, label, url, hidden } = route;
                        if(Boolean(hidden)) {
                            return null;
                        }

                        return (
                            <NavLink key={url} className={styles.link} activeClassName={styles.active} to={url}>
                                { icon ? <ReactSVG src={icon} className={styles.icon}/> : <div className={styles.icon} /> }
                                <span className={styles.label}>{label}</span>
                            </NavLink>
                        );
                    })}
                </div>
            </div>
            <div className={styles.footer}>
                <div className={styles.configs} title={'Terms and Conditions'} onClick={(e) => {
                    e.stopPropagation();
                    popoverDialogStore.showPopover(renderTermsAndConditionsContent())}}>
                    <div className={styles.link} >
                        <FontAwesomeIcon icon={faCircleInfo} className={styles.icon}/>
                    </div>
                </div>
                <div className={styles.info}>
                    <span>{authService.currentUser?.name || authService.currentUser?.username}</span>
                    <FontAwesomeIcon icon={faArrowRightFromBracket} className={styles.icon} onClick={_signOut}/>
                </div>
            </div>
            <div className={styles.toggle} onClick={_toggle}>
                <FontAwesomeIcon icon={faArrowLeft} className={styles.icon}/>
            </div>
        </div>
    );
});
